import { applyMove } from "@dailywars/core/engine";

import type { StoreState } from "#/game/store/types";

import { countMovesInLastUserAction } from "./undoActionSize";

export function undoLastMove(state: StoreState): StoreState {
  if (state.pendingMoves.length === 0) return state;

  const undoCount = countMovesInLastUserAction(state.pendingMoves);
  const pendingMoves = state.pendingMoves.slice(0, -undoCount);
  let localState = state.serverState;
  for (const move of pendingMoves) {
    localState = applyMove(localState, move).state;
  }

  return {
    ...state,
    localState,
    pendingMoves,
    selection: { mode: "none" },
    animation: null,
    animationQueue: [],
    previewAnimation: null,
  };
}
